import { Pipe, PipeTransform } from '@angular/core';
import { EnderecoPessoa } from '../models/pessoa.model';

@Pipe({
  name: 'formatarEnderecoPessoa'
})
export class FormatarEnderecoPessoaPipe implements PipeTransform {
  transform(enderecoPessoa: EnderecoPessoa, args?: any): any {
    let text = "";

    if (enderecoPessoa?.nome?.length == 0)
      return "";

    text = enderecoPessoa.nome;

    if (enderecoPessoa?.numero?.length > 0)
      text = text + ', ' + enderecoPessoa.numero;

    if (enderecoPessoa?.pontoRef?.length > 0)
      text = text + ', ' + enderecoPessoa.pontoRef;

    if (enderecoPessoa?.bairro?.length > 0)
      text = text + ', ' + enderecoPessoa.bairro;

    return text;
  }

}
